"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getApiErrorMessage = getApiErrorMessage;
var permission_error_1 = require("../constants/permission-error");
var permission_error_2 = require("./permission-error");
function getApiErrorMessage(error, fallback) {
    if ((0, permission_error_2.isPermissionDeniedError)(error)) {
        return permission_error_1.PERMISSION_DENIED_ACTION_MESSAGE;
    }
    if (typeof error !== "object" || error === null || !("data" in error)) {
        return fallback;
    }
    var data = error.data;
    if (typeof data !== "object" || data === null) {
        return fallback;
    }
    if ("content" in data && typeof data.content === "object" && data.content !== null && "message" in data.content) {
        var contentMessage = data.content.message;
        if (typeof contentMessage === "string" && contentMessage) {
            return contentMessage;
        }
    }
    return "message" in data && typeof data.message === "string" && data.message ? data.message : fallback;
}
